import * as classNames from "classNames";
import * as React from "react";
import { ITableConfig, sortDirection } from "../Table";

export interface ITableHeaderProps {
    col: ITableConfig[];
    cssWrapper?: string;
}

export const TableHeader = (props: ITableHeaderProps) => {
    if (!props.col) {return null;}
    return (
        <thead className={props.cssWrapper}>
            <tr className="sub-head">
                {props.col.map((ele, index) => {
                    return (
                        <th
                            key={`table-header-${index}`}
                            colSpan={ele.colSpan}
                            className={ele.thCssWrapper}
                            aria-sort={
                                ele.sortDirection
                                    ? ele.sortDirection == sortDirection.ASC
                                        ? "ascending"
                                        : "descending"
                                    : undefined
                            }
                        >
                            {ele.sortDirection ? (
                                <button className="ctable-sort-btn" onClick={ele.sorter ? () => ele.sorter() : null}>
                                    {ele.title}
                                    <span className="ctable-sort-icon" aria-hidden={true} />
                                    <span className="sr-only">Click to set ordering or toggle direction</span>
                                </button>
                            ) : (
                                <span className={ele.thInnerCss}>{ele.title}</span>
                            )}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};
